import { RegulationMenuComponent } from './../layout/regulation-menu.component';
import { FormService } from './../services/form.service';
import { ResponseService } from './../services/response.service';
import { RegulationsService } from './../services/regulations.service';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import { environment } from '../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './../services/api.service';

@Component({
  selector: 'app-main',
  templateUrl: './regulations.component.html'
})


export class AcceptingRegulations implements OnInit {

  public regulations: any;
  public actualRegulation: any;
  public selectedPosition: any;
  public regulationCount = 1;
  public API_URL: any = `${environment.api_url}`;
  public acceptRegulationForm: FormGroup;
  public view: any;

  constructor(
    private notificationService: NotificationsService,
    private domSanitizer: DomSanitizer,
    private formService: FormService,
    private responseService: ResponseService,
    private regService: RegulationsService,
    private route: Router,
    private trans: TranslateService,
    private apiService: ApiService
  ) {
    let controls = {
      acceptRegulation: new FormControl(false)
    };

    let validators = {
      acceptRegulation: [Validators.required, Validators.pattern('true')]
    };
    this.acceptRegulationForm = this.formService.buildForm(controls, validators);
  }

  ngOnInit() {
    this.ini();
  }

  ini() {
    this.notificationService.remove();
    if (this.regService.needAccepting() === true) {
      this.firstRegulation();
    } else {
      this.regService.checkRegulations().toPromise().then((accept) => {
        if (accept) {
          this.firstRegulation();
        } else {
          this.notificationService.success('Sukces!', this.trans.instant('RESPONSE.REGULATION.COMPLETED.ALL'));
          this.route.navigateByUrl('/panel');
        }
      });
    }
  }

  firstRegulation() {
    this.regulations = this.regService.getRegulations();
    this.actualRegulation = this.regulations[0];
    this.actualRegulation.position = 1;
    this.actualRegulation.accepted = false;
    this.setRegulation();
    this.regulationCount = this.regulations.length;
    return true;
  }

  getRegulationView() {
    this.view = this.domSanitizer.bypassSecurityTrustHtml('<object style="width:100%;height:100%" type="application/pdf"' +
      ' data="' + this.selectedPosition.viewHref + '">' +
      '<p>' + this.trans.instant('REGULATION.ERROR.CANT_BE_OPENED') + '</p>' +
      '<a href="' + this.selectedPosition.downloadHref + '" target="regulations" ' +
      'title="' + this.trans.instant('REGULATION.DOWNLOAD') + '">' +
      this.trans.instant('REGULATION.DOWNLOAD') + '</object>');
  }

  setRegulation() {
    this.selectedPosition = {
      name: this.actualRegulation.name,
      type: 'regulation',
      id: this.actualRegulation.id,
      viewHref: this.API_URL + '/regulation/' + this.actualRegulation.id + '?mode=view',
      downloadHref: this.API_URL + '/regulation/' + this.actualRegulation.fid
    };
    this.getRegulationView();
  }

  setAttachment(obj) {
    this.selectedPosition = {
      name: obj.name,
      type: 'attachment',
      id: obj.id,
      viewHref: this.API_URL + '/regulation/' + obj.id + '?mode=view',
      downloadHref: this.API_URL + '/regulation/' + obj.id
    };
    this.getRegulationView();
  }

  saveAcceptedRegulation() {
    if (this.acceptRegulationForm.valid) {
      let data = { regulation_id: this.actualRegulation.id };
      if (this.actualRegulation.type === 'wds') {
        data['contract_id'] = this.actualRegulation.contract.id;
      }
      this.apiService.post('/regulation/' + this.actualRegulation.type + '/accept', data)
        .subscribe(
        (response) => {
          this.notificationService.remove();
          this.notificationService.info('OK!', this.trans.instant('RESPONSE.REGULATION.' + response.status.message.toUpperCase()));
          this.goNextRegulation();
        },
        (error) => {
          this.responseService.error(error, this.acceptRegulationForm);
          this.regService.clear();
          this.ini();
        });
    } else {
      this.notificationService.error('Weryfikacja', this.trans.instant('RESPONSE.REGULATION.NEED.CHECK'));
    }
  }

  goNextRegulation() {
    if (this.actualRegulation.position + 1 > this.regulations.length) {
      this.regService.clear();
      this.ini();
      return;
    }
    this.acceptRegulationForm.controls.acceptRegulation.setValue(false);
    this.regulations[this.actualRegulation.position].position = this.actualRegulation.position + 1;
    this.actualRegulation = this.regulations[this.actualRegulation.position];
    this.actualRegulation.accepted = false;
    this.setRegulation();
  }
}



// WEBPACK FOOTER //
// ./src/app/accepting/regulations.component.ts